import api from "../../../api";

export default {
  async getLines({ commit }, query) {
    commit("REQUEST_LINES");
    commit("SET_LOADING", true, { root: true });
    try {
      commit(
        "SUCCESS_REQUEST_LINES",
        await api.getLines(query)
      );
    } catch (err) {
      commit("FAILURE_REQUEST_LINES");
    } finally {
      commit("SET_LOADING", false, { root: true });
    }
  },
  async deleteLine({ commit }, id) {
    commit("REQUEST_DELETE_LINE");
    commit("SET_LOADING", true, { root: true });
    try {
      commit(
        "SUCCESS_REQUEST_DELETE_LINE",
        await api.deleteLine(id)
      );
    } catch (err) {
      commit("FAILURE_REQUEST_DELETE_LINE");
    } finally {
      commit("SET_LOADING", false, { root: true });
    }
  },
  async updateLine({ commit }, item ) {
    commit("REQUEST_UPDATE_LINE");
    commit("SET_LOADING", true, { root: true });
    try {
      commit(
        "SUCCESS_REQUEST_UPDATE_LINE",
        await api.updateLine(item)
      );
    } catch (err) {
      commit("FAILURE_REQUEST_UPDATE_LINE");
    } finally {
      commit("SET_LOADING", false, { root: true });
    }
  },
  async createLine({ commit }, item ) {
    commit("REQUEST_CREATE_LINE");
    commit("SET_LOADING", true, { root: true });
    try {
      commit(
        "SUCCESS_REQUEST_CREATE_LINE",
        await api.createLine( item )
      );
    } catch (err) {
      commit("FAILURE_REQUEST_CREATE_LINE");
    } finally {
      commit("SET_LOADING", false, { root: true });
    }
  }
};
